// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Col, Row } from "@crehana/ui";
import cn from "classnames";
import { DiplomaCardSkeleton } from "../../../components/Cards/DiplomaCard";
import { jsx as _jsx } from "react/jsx-runtime";
var DiplomaListSkeleton = function DiplomaListSkeleton(_ref) {
  var _DiplomaCardSkeleton;
  var dataTestId = _ref['data-testid'],
    isDark = _ref.isDark;
  return /*#__PURE__*/_jsx(Row, {
    "data-testid": dataTestId,
    children: Array.from({
      length: 4
    }).map(function (_, i) {
      return /*#__PURE__*/_jsx(Col
      // biome-ignore lint/suspicious/noArrayIndexKey: index as key is acceptable here
      , {
        xs: 12,
        sm: 4,
        lg: 3,
        className: cn({
          'hidden sm:block': i === 1 || i === 2,
          'hidden lg:block': i === 3
        }),
        children: _DiplomaCardSkeleton || (_DiplomaCardSkeleton = /*#__PURE__*/_jsx(DiplomaCardSkeleton, {
          isDark: isDark
        }))
      }, "diploma-skeleton-".concat(i * 1));
    })
  });
};
export default DiplomaListSkeleton;